
import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import { X, Calendar } from 'lucide-react';

const CelebrationBanner: React.FC = () => {
  const { config, themes, currentThemeId } = useApp();
  const [isDismissed, setIsDismissed] = useState(false);

  // Reset dismissal when theme changes
  useEffect(() => {
    setIsDismissed(false);
  }, [currentThemeId]);

  if (!config.showCelebrationBanner || isDismissed) return null;

  const currentTheme = themes.find(t => t.id === currentThemeId);
  if (!currentTheme?.celebrationMessage) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[60] max-w-sm animate-fade-in-up">
       <div 
         className="relative p-4 rounded-xl shadow-2xl text-white flex items-start gap-3 backdrop-blur-md border border-white/20"
         style={{ backgroundColor: `${config.primaryColor}E6` }} // hex opacity ~90%
       >
          <div className="mt-1">
             <Calendar size={20} className="opacity-80"/>
          </div>
          <div className="flex-1">
            <p className="font-bold text-xs mb-1 uppercase tracking-wider opacity-80">Aktualna Okazja</p>
            <p className="text-sm font-medium leading-snug">{currentTheme.celebrationMessage}</p>
          </div>
          <button 
            onClick={() => setIsDismissed(true)}
            className="text-white/60 hover:text-white transition-colors p-1 hover:bg-white/10 rounded-full"
            title="Zamknij"
          >
            <X size={16} />
          </button>
       </div>
    </div>
  );
};
export default CelebrationBanner;
